export default __webpack_public_path__ + "static/media/seth.42cdc2a8.png";